import styled from 'styled-components';
import { media } from '../../styles/style-utils';
import logoFullSrc from '../../assets/images/logo-full.svg';
import Hyperlink from '../common/Hyperlink';

export const Logo = styled(Hyperlink)`
  background-image: url(${logoFullSrc});
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: calc(var(--fr) * 8);
  height: calc(var(--fr) * 3);
  width: calc(var(--fr) * 7);
  margin-left: calc(var(--fr) * -0.75);
  font-size: 0;
  display: inline-block;

  ${media.mediumLarge`
    height: calc(var(--fr) * 4);
    background-size: calc(var(--fr) * 10);
    margin-left: 0;
  `};
`;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/chrome/Logo.js